
let routes = [
  {
    path: '/oops', 
    component: render('Common/Opps'), 
    meta: { auth: true, title: 'Opps' },
  },
  {
    path: '/more', 
    component: render('Common/MoreSoon'), 
    meta: { auth: true, title: 'More' },
  },
  {
    path: '/bookmark', 
    component: render('Bookmark/BookmarkList'), 
    meta: { auth: true, title: 'Bookmark' },
  },
  {
    path: '/bookmark/:id',
    component: render('Bookmark/EditBookmark'),
    meta: { auth: true, title: 'Manage Bookmark' },
    props: true,
  },
  {
    path: '/gallery', 
    component: render('Gallery/GalleryList'), 
    meta: { auth: true, title: 'Gallery' },
  },
  {
    path: '/gallery/:id',
    component: render('Gallery/EditGallery'),
    meta: { auth: true, title: 'Manage Gallery' },
    props: true,
  },
  {
    path: '/passwords', 
    component: render('Passwords/PasswordsList'), 
    meta: { auth: true, title: 'Passwords' },
  },
  {
    path: '/passwords/:id',
    component: render('Passwords/EditPasswords'),
    meta: { auth: true, title: 'Manage Passwords' },
    props: true,
  },
  {
    path: '/projects', 
    component: render('Projects/ProjectList'), 
    meta: { auth: true, title: 'Projects' },
  },
  {
    path: '/projects/:id',
    component: render('Projects/EditProject'),
    meta: { auth: true, title: 'Manage Projects' },
    props: true,
  },
  {
    path: '/notes', 
    component: render('Notes/NotesList'), 
    meta: { auth: true, title: 'Notes' },
  },
  {
    path: '/notes/:id',
    component: render('Notes/EditNotes'),
    meta: { auth: true, title: 'Edit Notes' },
    props: true,
  },
  {
    path: '/firebaseadd', 
    component: render('Firebase/AddTutorial'), 
    meta: { auth: true, title: 'Firebase' },
  },
  {
    path: '/upload', 
    component: render('Firebase/Upload'), 
    meta: { auth: true, title: 'Firebase' },
  },
  {
    path: '/firebase', 
    component: render('Firebase/TutorialsList'), 
    meta: { auth: true, title: 'Firebase' },
  },
  {
    path: '/', 
    component: render('Bookmark/BookmarkList'), 
    meta: { auth: true, title: 'Bookmark' },
  },
  {
    path: '/login',
    component: render('Login'), 
    meta: { auth: false, authScreen: true },
  },
  {
    path: '/logout',
    component: render('Logout'), 
    meta: { auth: false, authScreen: true },
  },
  {
    path: '/home', 
    component: render('Home'), 
    meta: { auth: false, authScreen: true },
  },
  /*   --- Error Page ---   */
  { 
    path: '/404',
    component: render('Login'), 
    meta: { auth: false, authScreen: true },
  },
  { 
    path: '/*',
    redirect: '/oops',
    meta: { authScreen: true },
  },

  

  
]

function render(template) {
  return require(`@/pages/${template}.vue`).default
}

export default routes
